module.exports = __webpack_public_path__ + "static/media/gap-logo.056d7c02.png";